import { Component, OnInit, Injector, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { IProductService } from 'app/shared/iproduct.service';
import { TireService } from 'app/shared/tire.service';
import { PlacardToolKitDetailDtoResponse, PlacardToolKitVehicleDetailDtoResponse, PlacardToolPSIDtoResponse } from 'app/core/models/placard-tool.dto-response';
import { Helper } from 'app/shared/helper';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-tire-pressure-label',
  templateUrl: './tire-pressure-label.component.html',
  styleUrls: ['./tire-pressure-label.component.css']
})
export class TirePressureLabelComponent implements OnInit {
  @Input() kit: PlacardToolKitDetailDtoResponse;
  @Input() vehicle: PlacardToolKitVehicleDetailDtoResponse;
  subs: Subscription[] = [];
  productService: IProductService;
  psiList: PlacardToolPSIDtoResponse[];
  closeResult: string;
  public modalInstance;

  constructor(private injector: Injector,
    private modalService: NgbModal) { }

  ngOnInit() {
    this.productService = this.injector.get<TireService>(TireService);
    //const mym = `${this.vehice.make} ${this.vehice.make} ${this.vehice.make} ${this.vehice.make}`;
    this.subs.push(this.productService.getPlacardToolPSIs(this.vehicle.vehicleOptionID, this.kit.tireNo, this.kit.rearTireNo !== null && this.kit.rearTireNo !== "" ? this.kit.rearTireNo : null).subscribe(
      responseProduct => {
        if (responseProduct !== null) {
          this.psiList = responseProduct.cards;
          //this.showWaiting = false;
        } else {
          //this.showWaiting = false;
          //this.errorMessage = 'FC.ProductDetail.Error';
        }
      }, Helper.handleError));
  }

  open(content) {
    this.modalInstance = this.modalService.open(content, { windowClass: 'how-to-measure-modal' });//app-tire-pressure-label
    this.modalInstance.result.then((result) => {
      this.closeResult = 'Closed with: ${result}';
    }, (reason) => {
      this.closeResult = 'Dismissed ${this.getDismissReason(reason)}';
    });
  }

  convertPSITokPa(psi: number): number {
    return Math.round(psi * 6.8947572932);
  }

  hidePSI() {
    this.modalService.dismissAll(); //placard-tire-pressure-modal
  }

}
